import { Box, BoxProps } from '@mui/material';
import { memo } from 'react';

interface ILogoSmallProps extends BoxProps {
  color?: string;
  width?: number;
  height?: number;
}

const LogoSmall = ({
  width = 50,
  height = 50,
  color = '#fff',
  ...other
}: ILogoSmallProps) => {
  return (
    <Box {...other}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 50.725 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M31.005 0a18.261 18.261 0 0 0 -13.141 6.217L6.241 17.841c2.015 -1.767 4.404 -3.109 7.054 -3.862 0.177 -0.048 0.365 -0.107 0.554 -0.154a18.551 18.551 0 0 1 4.534 -0.565c10.138 0 18.37 8.22 18.37 18.37a18.551 18.551 0 0 1 -0.565 4.534c-0.046 0.188 -0.106 0.364 -0.152 0.553a18.37 18.37 0 0 1 -3.862 7.054l11.622 -11.623c3.674 -3.238 6.041 -7.913 6.217 -13.141V0z"
          fill={color}
        />
        <g opacity="0.5">
          <path
            d="M32.278 36.705c-0.212 0 -0.424 0.012 -0.636 0.012 -0.212 0 -0.424 0 -0.636 -0.012 -9.633 -0.33 -17.381 -8.078 -17.711 -17.71 0 -0.212 -0.012 -0.425 -0.012 -0.636s0 -0.424 0.012 -0.636c0.047 -1.342 0.236 -2.638 0.554 -3.898 -0.188 0.047 -0.365 0.106 -0.554 0.153C5.617 16.181 0 23.247 0 31.631 0 41.769 8.22 50 18.37 50c8.385 0 15.451 -5.617 17.652 -13.283 0.048 -0.177 0.107 -0.365 0.154 -0.554a18.406 18.406 0 0 1 -3.899 0.553z"
            fill={color}
          />
        </g>
      </svg>
    </Box>
  );
};

export default memo(LogoSmall);
